import { User, UserContext } from "@repo/baseCloud";
import { clone } from "@repo/helpers";
import { useContext, useEffect, useRef, useState } from "react";

import { useRepContext } from "../../contexts/editableItemContext";
import { useSettingsQuery } from "../../helpers/queryHooks";
import { Rep } from "../../models";
import { OnboardingRequirementsFull } from "../../models/onboardingRequirement";
import { OnboardingStates } from "../../models/onboardingSessions";
import { RepSettings } from "../../models/settings";

export default function useTemplateData<TData extends ITemplateData>(otherElements: Partial<TData>) {
	const { rep } = useRepContext();
	const [settings] = useSettingsQuery();
	const { user } = useContext(UserContext);
	const templateData = useRef({
		rep: clone(rep),
		settings,
		user,
		...otherElements,
	} as TData);
	const [dirty, setDirty] = useState(0);

	useEffect(() => {
		templateData.current = {
			rep: clone(rep),
			settings,
			user,
			...otherElements,
		} as TData;
		setDirty(dirty + 1);
	}, [rep, settings, user, otherElements]);

	return { templateData, dirty };
}

export interface ITemplateData {
	settings: RepSettings;
	rep: Rep;
	user: User;
	onboardingRequirements: OnboardingRequirementsFull;
	onboardingStates: OnboardingStates;
	loaded: boolean;
}
